module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "here-wallet-icon.3b7fb3a5.png";